import React from 'react';
import { GrFacebookOption, GrYoutube, GrTwitter, GrLinkedinOption } from "react-icons/gr";
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer flex justify-center items-center text-primary-content mt-5 px-5 py-5">
            <div className='text-center'>
                <div>
                    <p className="font-bold">
                        Providing reliable web tech since 2022
                    </p>
                    <p className='mt-2'>Copyright © 2022 - All right reserved by <span className='text-[orange]'>Ojit Deb Nath</span></p>
                </div>
                <div className="flex justify-evenly items-center mt-4 social">
                    <a href='https://www.linkedin.com/in/ojitdebnath/' target="_blank" rel="noreferrer">
                        <GrLinkedinOption className='h-6 w-6' />
                    </a>
                    <a href='https://twitter.com/OjitDebNath' target="_blank" rel="noreferrer">
                        <GrTwitter className='h-6 w-6' />
                    </a>
                    <a href='https://www.youtube.com/channel/UCw2BRXApL3hgCnOf3rvshZA' target="_blank" rel="noreferrer">
                        <GrYoutube className='h-6 w-6' />
                    </a>
                    <a href='https://www.facebook.com/ojitdebnath0' target="_blank" rel="noreferrer">
                        <GrFacebookOption className='h-6 w-6' />
                    </a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;